export class FormFiller {
	init(){
		var object = null,
			people = null;

		$('.table-price a.btn, .sezon-table a.btn').each(function() {
			$(this).on('click', function() {
				object = $(this).data('object');
				people = $(this).data('people');

				object !== null ? localStorage.setItem('formObject', object): '';
				people !== null ? localStorage.setItem('formPeople', people) : '';
			});
		})

		if($('#contactForm #place').length && localStorage.getItem('formObject') !== null && localStorage.getItem('formObject') !== 'undefined'){
			$('#contactForm #place').val(localStorage.getItem('formObject'));

			localStorage.removeItem('formObject');
		}

		if($('#contactForm #guests').length && localStorage.getItem('formPeople') !== null && localStorage.getItem('formPeople') !== 'undefined'){
			$('#contactForm #guests').val(localStorage.getItem('formPeople'));

			localStorage.removeItem('formPeople');
		}

	}
}